<template>
  <div class="diagram-bar-chart">
    <div
      class="diagram-bar-chart__graph-sec"
      :style="{minHeight:`${lineHeight * lineLen}px`,paddingLeft:`${paddingLeft}px`}"
    >
      <div
        class="diagram-bar-chart__graph-sec__content"
        :style="{minHeight:`${lineHeight * lineLen}px`}"
      >
        <div class="diagram-bar-chart__graph-sec__content-bar-sec">
          <div
            v-for="(bar,barKey,barIndex) in _getEventsBarUsing"
            :key="barKey"
            class="diagram-bar-chart__graph-sec__content-bar"
            :class="{shadow:ingHover!=barIndex && ingHover!=-1}"
            :style="{height:`${lineHeight * lineLen}px`}"
          >
            <div
              v-for="(barItem, barItemKey, barItemIndex) in bar"
              :key="barItemKey"
              class="diagram-bar-chart__graph-sec__content-bar-item"
              :class="itemsChecked[barItemIndex]"
              :style="{height: `${$_getBarHeight(barItem)}%`,backgroundColor:$_gerBarColor(barItemKey)}"
            />
          </div>
        </div>
        <div class="diagram-bar-chart__graph-sec__content-bg">
          <div
            v-for="(bg,bgIndex) in lineLen"
            :key="bgIndex"
            class="diagram-bar-chart__graph-sec__content-bg-item"
          />
        </div>
        <DiagramTooltip
          :label-width="14"
          :label-height="14"
          :label-radius="4"
          :tooltips="_tooltips"
          :length="bottomLabels.length"
          @hover-in="$_setIngHover($event)"
          @hover-out="$_unsetIngHover()"
        />
      </div>
      <DiagramFrequencySec
        :frequency-range="[yMax,0]"
        :title="yTitle"
        :max="lineLen"
        :unit="frequencyUnit"
      />
    </div>
    <div
      class="diagram-bar-chart__bottom-label-sec"
      :style="{paddingLeft:`${paddingLeft}px`}"
    >
      <div
        v-for="(label,labelIndex) in bottomLabels"
        :key="labelIndex"
        class="diagram-bar-chart__bottom-label"
      >
        {{ label }}
      </div>
    </div>
    <DiagramSwitchSec
      :padding-left="paddingLeft"
      :title="switchBtnTitle"
      @pre-click="$_switchSecPreClick($event)"
      @next-click="$_switchSecNextClick($event)"
    />
    <DiagramStatusLabel
      v-if="showStatusLabel"
      :status-items="statusItems"
      :value="itemsChecked"
      :label-width="14"
      :label-height="14"
      :label-radius="4"
      @input="$_statusOnChange($event)"
    />
  </div>
</template>
<script>
export default {
  name: "DiagramBarChart",
  props: {
    yTitle: {
      type: String,
      default: "",
    },
    statusItems: {
      type: Array,
      default() {
        return [];
      },
    },
    yMax: {
      type: Number,
      default: 0,
    },
    lineLen: {
      type: Number,
      default: 0,
    },
    bottomLabels: {
      type: Array,
      default() {
        return [];
      },
    },
    eventsList: {
      type: Object,
      default() {
        return {};
      },
    },
    tooltips: {
      type: Object,
      default() {
        return {};
      },
    },
    paddingLeft: {
      type: Number,
      default: 0,
    },
    switchBtnTitle: {
      type: String,
      default: "",
    },
    lineHeight: {
      type: Number,
      default: 24,
    },
    frequencyUnit: {
      type: String,
      default: "",
    },
    hasSelected: {
      type: Boolean,
      default: false,
    },
    showStatusLabel: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    itemsChecked: [],
    ingHover: -1,
  }),
  computed: {
    _getEventsBarUsing() {
      const eventsBarUsing = {};
      this.bottomLabels.forEach(label => {
        const eventsBar = this.eventsList[label];
        let result = {};
        if (eventsBar) {
          this.statusItems.forEach(status => {
            if (this.itemsChecked.includes(status.value)) {
              result[status.type] = eventsBar[status.type];
            }
          });
          eventsBarUsing[label] = result;
        } else {
          eventsBarUsing[label] = result;
        }
      });
      return eventsBarUsing;
    },
    _tooltips() {
      let _tooltips= {...this.tooltips}
      if (this.itemsChecked.length > 1){
        return _tooltips
      } else {
        const _statusItems = this.statusItems.filter((status)=>this.itemsChecked.includes(status.value))
        for (let tooltip in _tooltips){
          _tooltips[tooltip] = _tooltips[tooltip].filter((item)=>_statusItems.filter((status)=> status.text === item.title).length >0)
        }
        return _tooltips
      }
    },
    _yMax(){
      let _yMax = 0;
      let remainder =
        this.yMax % this.lineLen;
      _yMax =
        remainder > 0
          ? this.yMax + (this.lineLen - remainder)
          : this.yMax;
      return _yMax;
    }
  },
  watch: {
    statusItems: {
      deep: true,
      immediate: true,
      handler() {
        this.$_setItemsChecked();
      },
    },
  },
  methods: {
    $_statusCheck(status) {
      let check = false;
      for (let i = 0; i < this.itemsChecked.length; i++) {
        const itemsCheckedItem = this.itemsChecked[i];
        if (itemsCheckedItem == status) {
          check = true;
        }
      }
      return check;
    },
    $_statusColor(status) {
      let checked = this.$_statusCheck(status.value);
      return checked ? status.color : status.disabledColor;
    },
    $_setItemsChecked() {
      this.itemsChecked = this.statusItems.map((item) => item.value);
    },
    $_getBarHeight(bar_e) {
      return (bar_e / this._yMax) * 100;
    },
    $_gerBarColor(barItemKey) {
      let itemsChecked = null
      if (barItemKey !== "all") {
        itemsChecked = this.statusItems.find(
          (item) => item.type === barItemKey
        );
      } else {
        itemsChecked = this.statusItems[0]
      }
      return itemsChecked ? itemsChecked.color : "#a01d11";
    },
    $_setIngHover(index) {
      this.ingHover = index;
    },
    $_unsetIngHover() {
      this.ingHover = -1;
    },
    $_statusOnChange($event) {
      this.itemsChecked = $event;
    },
    $_switchSecPreClick($event) {
      this.$emit("pre-click", $event);
    },
    $_switchSecNextClick($event) {
      this.$emit("next-click", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diagram-bar-chart";
</style>